import { Action } from '@ngrx/store';
import { LookupModel } from '../../../common/models/LookupModel';
import { UserGroupModel } from '../../models/UserGroupModel';

export const ADD_ALL_GROUPS_TO_USER_SUCCESS = '[Customer] User Add Group Success';

export class AddAllGroupsToUserSuccessAction implements Action {
  readonly type = ADD_ALL_GROUPS_TO_USER_SUCCESS;

  constructor(public payload: { userKey: string, userGroups: LookupModel[] }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/AddAllGroupsToUserSuccessAction.ts